import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { IAppointment, Schedule } from "./appointment.interface";
import { ITaskAppointmentFilter } from "../task.interface";
import { HttpService } from "../../../../../http.service";
import { UtilsService } from "../../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../../env-config";

@Injectable({ providedIn: 'root' })
export class AppointmentsService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getAppointments(filter?: ITaskAppointmentFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_APPOINTMENT)}${queryParams}`);
  }

  getAppointmentsReduce(filter?: ITaskAppointmentFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_APPOINTMENT)}/calendar${queryParams}`);
  }

  getAppointment(appointment: IAppointment | string): Observable<any> {
    let id = (typeof appointment == 'string') ? appointment : appointment._id;
    return this._http.get(`${apiURL(EnvConfig.API_APPOINTMENT)}/${id}`);
  }

  createAppointment(appointment: IAppointment): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_APPOINTMENT)}`, appointment);
  }

  updateAppointment(appointment: IAppointment): Observable<any> {
    let id = appointment._id;
    delete appointment._id;
    return this._http.patch(`${apiURL(EnvConfig.API_APPOINTMENT)}/${id}`, appointment);
  }

  updateManyAppointment(appointment: IAppointment): Observable<any> {
    let id = appointment._id;
    delete appointment._id;
    return this._http.patch(`${apiURL(EnvConfig.API_APPOINTMENT)}/${id}/many`, appointment);
  }

  deleteAppointment(appointment: IAppointment | string): Observable<void> {
    let id = (typeof appointment == 'string') ? appointment : appointment._id;
    return this._http.delete(`${apiURL(EnvConfig.API_APPOINTMENT)}/${id}`);
  }

  checkDeleteManyAppointment(data: any): Observable<void> {
    return this._http.post(`${apiURL(EnvConfig.API_APPOINTMENT)}/check-remove-many`, data);
  }

  deleteManyAppointment(data: any): Observable<void> {
    return this._http.post(`${apiURL(EnvConfig.API_APPOINTMENT)}/remove-many`, data);
  }

  restoreAppointment(appointment: IAppointment | string): Observable<void> {
    let id = (typeof appointment == 'string') ? appointment : appointment._id;
    return this._http.post(`${apiURL(EnvConfig.API_APPOINTMENT)}/${id}/restore`, null);
  }

  //QUITAR DE ACA

  createRecurrenceRule(schedule: Schedule): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_SCHEDULE)}`, schedule);
  }
}